import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Building2, LineChart, Globe2, ArrowRight } from 'lucide-react';
import PageBanner from '../components/PageBanner';
import Reveal from '../components/Reveal';

const DISCIPLINES = [
  { icon: GraduationCap, title: 'School Leadership', text: 'Former principals and senior leaders who have run schools across British, American, IB and Indian curricula.' },
  { icon: Building2, title: 'Operations & Regulation', text: 'Specialists who understand licensing, inspection frameworks and the realities of operating in each emirate.' },
  { icon: LineChart, title: 'Data & Research', text: 'Analysts who turn raw sector data into clear supply, demand and fee-positioning intelligence.' },
  { icon: Globe2, title: 'Marketing & Admissions', text: 'Practitioners in school marketing, digital strategy and admissions growth within a competitive UAE market.' },
];

export default function Consultants() {
  return (
    <div>
      <PageBanner
        title="Consultants at EIG"
        subtitle="An array of consultants across multiple disciplines — in schools, regulatory bodies and across curricula."
        crumb="Consultants at EIG"
        image="https://images.unsplash.com/photo-1714974528737-3e6c7e4d11af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzkwODQ5MjY0fDA&ixlib=rb-4.1.0&q=85"
      />

      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
          <Reveal>
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-[#132b4d] eig-section-title">
              Experience with depth
            </h2>
            <p className="mt-8 text-gray-600 leading-relaxed text-lg">
              Our consultants work across the education sector — in schools, in regulatory bodies, across curricula
              and in very different roles. The chances are we can meet your needs and requirements. In the first
              instance we simply meet to talk through the challenges you are facing, then put together a needs-based
              plan that is very much fit for purpose.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 eig-graph">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
            {DISCIPLINES.map((d, i) => (
              <Reveal key={d.title} delay={i * 80}>
                <div className="flex gap-5 bg-white rounded-xl p-8 h-full shadow-sm hover:shadow-lg transition-shadow duration-300">
                  <div className="w-14 h-14 shrink-0 rounded-lg bg-[#eaf6fc] text-[#1ca5dc] flex items-center justify-center">
                    <d.icon size={26} />
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-xl text-[#132b4d] mb-2">{d.title}</h3>
                    <p className="text-gray-600 leading-relaxed text-sm">{d.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-5 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          {[['35+', 'Years of combined sector experience'], ['4', 'Curricula covered end-to-end'], ['7', 'Emirates within our research reach']].map((stat, i) => (
            <Reveal key={stat[1]} delay={i * 100}>
              <div className="py-8">
                <div className="font-heading font-extrabold text-5xl text-[#1ca5dc]">{stat[0]}</div>
                <p className="mt-3 text-gray-600 font-medium">{stat[1]}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="text-center mt-6">
          <Link to="/contact" className="inline-flex items-center gap-2 bg-[#1ca5dc] text-white font-heading font-semibold px-8 py-3.5 rounded-full hover:bg-[#132b4d] transition-colors">
            Work with our consultants <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
}
